import $ from 'gridstrap/lib/gs-zepto';

export class GSTableOfContents {

	//
	// Properties
	//

	private root;
	private items;
	private groups;
	private emptyMessage;

	set isEmpty(value) { this.emptyMessage.toggleClass('d-none', !value); }

	//
	// Public Methods
	//

	filter(value) {
		let matches = 0;

		this.items.forEach(el => {
			let item = $(el);
			let matchString = item.data('gsTableOfContentsMatchString');
			let isMatch = this.isMatch(value, matchString);
			item.toggleClass('is-hidden', !isMatch);
			if (isMatch) matches++;
		});

		this.groups.forEach(el => {
			let group = $(el);
			let items = group.find('.gs-TableOfContents-item');
			let visible = items.not('.is-hidden');
			group.toggleClass('is-hidden', visible.length == 0);
			items.removeClass('is-last');
			visible.last().addClass('is-last');
		});

		this.isEmpty = (matches == 0);
	}

	private isMatch(query, full) {
		let words = this.sanitize(query).split(' ');
		let pattern = new RegExp('\\b' + words.join('\\s(\\S+\\s)*'), 'i');
		return pattern.test(this.sanitize(full));
	}

	private sanitize(query) {
		return query
			.replace(/[^a-z0-9 ]/i, '')
			.replace(/ {2,}/g, ' ');
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.items = this.root.find('.gs-TableOfContents-item');
		this.groups = this.root.find('.gs-TableOfContents-group');
		this.emptyMessage = this.root.find('.gs-TableOfContents-empty');
	}
}
